import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    templateUrl: './logout.component.html',
    imports: [RouterLink]
})

export class LogoutComponent {

}